import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const BASE_URL = "https://chat.wivoanalytics.com";
const CLAIM = "https://wivoanalytics.com/chatwoot";

// Carga el widget in-app de Chatwoot (inbox "Wivo Sensores") e identifica al
// usuario logueado vía HMAC. Análogo a kodkod-v2, con dos diferencias:
//   1. Inbox propio "Wivo Sensores" (aísla la bandeja: un agente miembro solo
//      de ese inbox ve únicamente estas conversaciones).
//   2. Usa el identifier_hash_sensores del claim (firmado con el HMAC secret
//      del inbox de sensores), no el identifier_hash de "Wivo App".
//
// identifier = auth0|sub (igual que kodkod). El widget NO empuja tenant/plan:
// el contexto de cuenta lo enriquece el pipeline crm-sync en Chatwoot, keyed
// por el mismo identifier — no se duplica desde acá. (Los usuarios de sensores
// son multi-tenant vía el claim `sensors_tenant`; eso lo resuelve crm-sync.)
const ChatwootWidget = () => {
  const { isAuthenticated, user } = useAuth0();

  useEffect(() => {
    const token = process.env.REACT_APP_CHATWOOT_SENSORES_TOKEN;
    if (!isAuthenticated || !token || !user) return undefined;

    const ctx = user[CLAIM];
    if (!ctx || !ctx.identifier_hash_sensores) return undefined; // sin hash del inbox de sensores no identificamos

    const identify = () => {
      if (!window.$chatwoot) return;
      // name/email desde los claims estándar (siempre presentes con scope
      // "profile email"); del claim custom solo el identifier + su HMAC.
      window.$chatwoot.setUser(ctx.identifier, {
        name: user.name,
        email: user.email,
        identifier_hash: ctx.identifier_hash_sensores,
      });
    };

    if (window.chatwootSDK) {
      identify(); // ya cargado (re-render): re-identificar, sin re-inyectar el SDK
    } else {
      window.addEventListener("chatwoot:ready", identify);
      const script = document.createElement("script");
      script.src = `${BASE_URL}/packs/js/sdk.js`;
      script.async = true;
      script.defer = true;
      script.onload = () =>
        window.chatwootSDK.run({ websiteToken: token, baseUrl: BASE_URL });
      document.head.appendChild(script);
    }

    return () => {
      window.removeEventListener("chatwoot:ready", identify);
    };
  }, [isAuthenticated, user]);

  return null;
};

export default ChatwootWidget;
